import { TEDCustomNumberParser } from './TEDCustomNumberParser';
import { TEDParseNumberMode } from '../FormatterTypes';

export class TEDParseDegrees extends TEDCustomNumberParser {
  public static getInstance(): TEDParseDegrees {
    return this.instance ? this.instance : (this.instance = new this());
  }
  private static instance: TEDParseDegrees;

  mode(): TEDParseNumberMode {
    return TEDParseNumberMode.pnmDegrees;
  }
}
